import { Pipe, PipeTransform } from '@angular/core';
import filter from 'lodash-es/filter';

@Pipe({ name: 'filter' })
export class TrainingsLocationFilterPipe implements PipeTransform {
    transform(value: any, searchText: string): any {
        var selectedCountry = {
            countryCode: searchText,
        };
        if (value !== undefined && value !== null) {
            return filter(value, selectedCountry);
        }
        return value;
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/trainings-location-filter.pipe.ts